<template>
  <div>
    <div class="shadow-card top-card">
      <div class="back-button">
        <span :style="{ color: getPrimaryColor(), cursor: 'pointer' }" @click="$router.go(-1)">
          <font-awesome-icon class="mr-2" :style="{ color: getPrimaryColor() }" :icon="['fas', 'arrow-left']" />
          Back
        </span>
      </div>
      <h3 class="top-title">Physician Directory</h3>
      <div class="top-middle-content">
        <div class="top-input-container">
          <font-awesome-icon :icon="['fal', 'search']" :style="{ color: getPrimaryColor(), width: '20px' }" class="cp ml-3" @click="getDoctors" />
          <a-input type="search" class="search-field" placeholder="Search physicians" v-model="searchFullName" @input="callDebounce"> </a-input>
          <a-icon v-if="searchFullName" class="close-icon-size cp mr-3" type="close" @click="handleClearSearchWord" />
        </div>
        <button class="search-button position-relative" @click="$refs.FilterModal.show()">
          <img src="../../assets/images/filter_icon.svg" alt="filter icon" height="14px" width="18px" />
          <span class="filter-text">Apply Filters</span>
          <div
            v-if="
              searchCity !== '' || searchState !== '' || searchLastName !== '' || searchFirstName !== '' || searchSpeciality !== undefined || searchGender !== '' || recommended || claimed || premium
            "
            class="active-filter-indicator"
            :style="{ background: getPrimaryColor() }"
          />
        </button>
      </div>
      <div
        v-if="searchCity !== '' || searchState !== '' || searchLastName !== '' || searchFirstName !== '' || searchSpeciality !== undefined || searchGender !== '' || recommended || claimed || premium"
        class="top_filters"
      >
        <div class="filter-container">
          <div class="appliedFilter">Applied Filter:</div>
          <div v-if="searchFirstName !== ''" class="filterTypeBox">
            <div class="filterTypeText">{{ searchFirstName }}</div>
            <i class="fa fa-times" aria-hidden="true" style="cursor: pointer" @click="() => clearFilterType('searchFirstName')"></i>
          </div>
          <div v-if="searchLastName !== ''" class="filterTypeBox">
            <div class="filterTypeText">{{ searchLastName }}</div>
            <i class="fa fa-times" aria-hidden="true" style="cursor: pointer" @click="() => clearFilterType('searchLastName')"></i>
          </div>
          <div v-if="searchCity !== ''" class="filterTypeBox">
            <div class="filterTypeText">{{ searchCity }}, {{ searchState }}</div>
            <i class="fa fa-times" aria-hidden="true" style="cursor: pointer" @click="() => clearFilterType('searchCity')"></i>
          </div>
          <div v-if="searchSpeciality !== undefined" class="filterTypeBox">
            <div class="filterTypeText">{{ searchSpeciality }}</div>
            <i class="fa fa-times" aria-hidden="true" style="cursor: pointer" @click="() => clearFilterType('searchSpeciality')"></i>
          </div>
          <div v-if="searchGender !== ''" class="filterTypeBox">
            <div class="filterTypeText">
              {{ searchGender === "m" ? "Male" : searchGender === "f" ? "Female" : "Other" }}
            </div>
            <i class="fa fa-times" aria-hidden="true" style="cursor: pointer" @click="() => clearFilterType('searchGender')"></i>
          </div>
          <div v-if="recommended" class="filterTypeBox">
            <div class="filterTypeText">Is Recommended</div>
            <i class="fa fa-times" aria-hidden="true" style="cursor: pointer" @click="() => clearFilterType('recommended')"></i>
          </div>
          <div v-if="premium" class="filterTypeBox">
            <div class="filterTypeText">Is Premium</div>
            <i class="fa fa-times" aria-hidden="true" style="cursor: pointer" @click="() => clearFilterType('premium')"></i>
          </div>
          <div v-if="claimed" class="filterTypeBox">
            <div class="filterTypeText">Is Claimed</div>
            <i class="fa fa-times" aria-hidden="true" style="cursor: pointer" @click="() => clearFilterType('claimed')"></i>
          </div>
        </div>
        <div class="clear-filter" :style="{ color: getPrimaryColor() }" @click="clearFilters">Clear Filters</div>
      </div>
    </div>
    <SearchOnMapComponent type="physician" :search="searchFullName" />
    <div v-if="loading" class="d-flex justify-content-center mt-3 mb-3">
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
    </div>
    <div v-if="doctorsList.results && doctorsList.results.length > 0 && !loading" class="page-info sort-dropdown">
      <p class="result-length">{{ totalResults }} Results</p>
      <a-dropdown style="margintop: 7px" :trigger="['click']" :getPopupContainer="trigger => trigger.parentNode">
        <p class="sort-text">
          Show
          <span style="font-weight: 700">{{ sortList[sortKey] }}</span>
          <font-awesome-icon size="lg" style="margin-left: 8px" :icon="['fas', 'angle-down']" />
        </p>
        <template #overlay>
          <a-menu @click="e => sortContent(e.key)">
            <a-menu-item key="distance">Closest to you</a-menu-item>
            <a-menu-item key="rating">Highest rated first</a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
    <div v-if="!loading && doctorsList.results && doctorsList.results.length === 0">
      <div class="no-results-container">
        <div class="no-results-icon">
          <font-awesome-icon :icon="['fal', 'search']" :style="{ color: '#A1BDE6', width: '20px' }" size="lg" />
        </div>
        <p class="text1">No Results Found</p>
        <p class="text2">
          We couldn’t find any results based on your search.<br />
          Please try searching with another term.<br /><br />Would you like to add this profile on DoveMed?
        </p>
        <p class="text3" :style="{ color: getPrimaryColor() }" id="add" @click="() => handlePhysicianModal(currentCircle.id)">Add Physician Profile</p>
      </div>
    </div>
    <div>
      <div class="doctors-search-result" v-if="!loading && doctorsList.results && doctorsList.results.length > 0">
        <div class="mb-2" v-for="doctor in doctorsList.results" :key="doctor.id">
          <DirectoryCard :info="doctor" :type="'physician'" :fetchDoc="getDoctors" />
        </div>
        <div :style="{ padding: '30px', display: 'flex', justifyContent: 'center' }">
          <a-pagination show-less-items class="dovemed-custom-pagination" :total="totalResults" :pageSize="10" v-model="currentPage" @change="handleChangePage" />
        </div>
      </div>
    </div>
    <AddPhysicianModal ref="AddPhysicianModal" :handleChangeTab="() => {}" />
    <PhysicianFilterModal
      ref="FilterModal"
      :searchFirstName="searchFirstName"
      :searchLastName="searchLastName"
      :searchCity="searchCity"
      :searchState="searchState"
      :searchSpeciality="searchSpeciality"
      :searchGender="searchGender"
      :specialities="specialities"
      :handleSelectLocation="handleSelectLocation"
      :locationList="locationList"
      :handleAnswer="handleAnswer"
      :recommended="recommended"
      :claimed="claimed"
      :premium="premium"
    />
  </div>
</template>

<script>
import AddProvider from "../home/provider/AddProvider"
import DirectoryCard from "../home/provider/DirectoryCard.vue"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
import AddPhysicianModal from "../Modals/AddPhysicianModal"
import PhysicianFilterModal from "../Modals/PhysicianDirectoryFilterModal.vue"
import SearchOnMapComponent from "../commons/SearchOnMapComponent.vue"

const MedicalRepository = RepositoryFactory.get("medicaldirectory")
const UserRepository = RepositoryFactory.get("user")
const AppRepository = RepositoryFactory.get("app")

export default {
  name: "ProviderDirectory",
  components: {
    AddProvider,
    DirectoryCard,
    AddPhysicianModal,
    PhysicianFilterModal,
    SearchOnMapComponent,
  },
  data() {
    return {
      doctorsList: { results: [] },
      speciality: undefined,
      specialities: [],
      locationList: [],
      searchFullName: "",
      searchFirstName: "",
      searchLastName: "",
      searchCity: "",
      searchState: "",
      searchSpeciality: undefined,
      recommended: false,
      claimed: false,
      premium: false,
      searchGender: "",
      currentPage: 1,
      totalResults: 0,
      state: [],
      loading: true,
      sortKey: "distance",
      sortList: { distance: "Closest to you", rating: "Highest rated first" },
      Mylocation: { lat: null, lng: null },
      payloadlocation: { lat: undefined, lng: undefined },
    }
  },

  mounted() {
    console.warn("ProviderDirectory.vue is mounted")

    this.getSpecialities()
    this.handleSelectLocation()
    this.searchFullName = this.$route.params.search ? this.$route.params.search : ""
    this.payloadlocation = this.$route.params.payloadloc
    if (this.$route.params.location) {
      this.Mylocation.lat = this.$route.params.location.lat ? this.$route.params.location.lat : null
      this.Mylocation.lng = this.$route.params.location.lng ? this.$route.params.location.lng : null
    }
    this.getDoctors()
  },

  methods: {
    getDoctors() {
      // console.log("getDoctors() is called")
      const payload = {
        northEast: { lat: 57.539416794474995, lng: -62.05078125000001 },
        northWest: { lat: 57.539416794474995, lng: -128.67187500000003 },
        southEast: { lat: 15.029685756555674, lng: -62.05078125000001 },
        southWest: { lat: 15.029685756555674, lng: -128.67187500000003 },
        // northEast: {
        //   lat: this.Mylocation.lat ? this.Mylocation.lat : 57.539416794474995,
        //   lng: this.Mylocation.lng ? this.Mylocation.lng : -62.05078125000001,
        // },
        // northWest: {
        //   lat: this.Mylocation.lat ? this.Mylocation.lat : 57.539416794474995,
        //   lng: this.Mylocation.lng ? this.Mylocation.lng : -128.67187500000003,
        // },
        // southEast: {
        //   lat: this.Mylocation.lat ? this.Mylocation.lat : 15.029685756555674,
        //   lng: this.Mylocation.lng ? this.Mylocation.lng : -62.05078125000001,
        // },
        // southWest: {
        //   lat: this.Mylocation.lat ? this.Mylocation.lat : 15.029685756555674,
        //   lng: this.Mylocation.lng ? this.Mylocation.lng : -128.67187500000003,
        // },
        precision: "2000km",
        numberOfBuckets: 1000,
        filters: { item_type: "physician" },
      }
      if (this.searchFullName) payload.filters.search_name = this.searchFullName
      if (this.searchFirstName) payload.filters.first_name = this.searchFirstName
      if (this.searchLastName) payload.filters.last_name = this.searchLastName
      if (this.searchCity) payload.filters.city = this.searchCity
      if (this.searchState) payload.filters.state = this.searchState
      if (this.searchGender) payload.filters.gender = this.searchGender
      if (this.searchSpeciality) payload.filters.speciality = this.searchSpeciality
      if (this.recommended) payload.filters.is_recommended = "true"
      if (this.claimed) payload.filters.is_claimed = "true"
      if (this.premium) payload.filters.is_premium = "true"
      this.loading = true
      document.body.scrollTop = 0
      MedicalRepository.PostMedicalDirectorySearch(this.currentPage, 10, this.currentCircle.id, this.sortKey, payload, this.payloadlocation)
        .then(res => {
          if (res.data.results.length) {
            this.doctorsList.results = res.data.results
          } else {
            this.doctorsList.results = []
          }
          // this.currentPage = res.data.page;
          this.totalResults = res.data.totalResults
          this.loading = false
        })
        .catch(() => (this.loading = false))
    },
    handleAnswer(searchCity, searchState, searchSpeciality, searchGender, searchFirstName, searchLastName, recommended, premium, claimed) {
      this.searchGender = searchGender
      this.searchSpeciality = searchSpeciality
      this.searchCity = searchCity
      this.searchState = searchState
      this.searchFirstName = searchFirstName
      this.searchLastName = searchLastName
      this.recommended = recommended
      this.premium = premium
      this.claimed = claimed
      this.currentPage = 1
      this.getDoctors()
    },
    handleClearSearchWord() {
      this.searchFullName = ""
      this.currentPage = 1
      this.getDoctors()
    },
    handlePhysicianModal(circle_id) {
      this.$refs.AddPhysicianModal.showModal(circle_id)
    },
    getSpecialities() {
      AppRepository.getSpecialities()
        .then(res => {
          this.specialities = res.data.data
        })
        .catch(err => {})
    },
    handleSelectLocation(value = ""){
      AppRepository.getLocations(value)
        .then(res => {
          if (res.data.data.hasOwnProperty("data")) {
            this.locationList = res.data.data.data;
          } else {
            this.locationList = [];
          }
        })
        .catch(err => {})
    },
    handleChangePage(page, pageSize) {
      this.getDoctors()
    },
    callDebounce: _.debounce(function () {
      console.warn("callDebounce")
      this.currentPage = 1
      this.getDoctors()
    }, 500),

    sortContent(sort) {
      this.sortKey = sort
      this.currentPage = 1
      this.getDoctors()
    },
    getAllStates() {
      this.state = AppRepository.getAllStates()
    },
    clearFilterType(type) {
      if (type === "searchCity") {
        this.searchCity = ""
        this.searchState = ""
      } else if (type === "searchSpeciality") {
        this.searchSpeciality = undefined
      } else if (type === "searchGender") {
        this.searchGender = ""
      } else if (type === "searchLastName") {
        this.searchLastName = ""
      } else if (type === "searchFirstName") {
        this.searchFirstName = ""
      } else if (type === "recommended") {
        this.recommended = false
      } else if (type === "premium") {
        this.premium = false
      } else if (type === "claimed") {
        this.claimed = false
      }
      this.currentPage = 1
      this.getDoctors()
    },
    clearFilters() {
      this.searchFirstName = ""
      this.searchLastName = ""
      this.searchCity = ""
      this.searchState = ""
      this.searchSpeciality = undefined
      this.searchGender = ""
      this.recommended = false
      this.premium = false
      this.claimed = false
      this.currentPage = 1
      this.getDoctors()
    },
  },
}
</script>

<style lang="scss">
.dovemed-custom-pagination .ant-pagination-item-active {
  background: #2a71d4;
}

.dovemed-custom-pagination .ant-pagination-item-active a {
  color: #ffffff !important ;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
}

.dovemed-custom-pagination .ant-pagination-item-active a:hover {
  color: #ffffff !important;
}
</style>

<style lang="scss" scoped>
.signup-page {
  padding: 70px;
}

.top-card {
  margin-bottom: 48px;
  @media only screen and (max-width: 700px) {
    box-shadow: none;
    margin: 0px;
    padding: 24px 0px;
  }
  .back-button {
    font-family: "Lato";
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 27px;
    text-align: start;
  }
  .top-title {
    display: flex;
    margin-top: 0px;
    margin-bottom: 24px;
    font-size: 32px;
    font-weight: 700;
    color: #0f1734;
  }
  .top-middle-content {
    @media screen and (min-width: 701px) {
      display: flex;
    }
  }
  .top-input-container {
    display: flex;
    background: #f1f5f9;
    border-radius: 8px;
    margin-right: 24px;
    height: 60px;
    width: 100%;
    align-items: center;
    .search-field {
      background: #f1f5f9;
      border-radius: 8px;
      border: none;
      font-weight: 700;
      font-size: 16px;
      line-height: 32px;
      color: #0f1734;
      height: 60px;
      width: 100%;
    }
    input::placeholder {
      font-weight: 400;
    }
    .close-icon-size {
      font-size: 15px;
    }
  }
  .search-button {
    width: 60px;
    height: 60px;
    background: #f1f5f9;
    border-radius: 8px;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 700px) {
      width: 100%;
      margin-top: 16px;
    }
    .active-filter-indicator {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      align-self: flex-start;
      margin-top: 18px;
      margin-left: 5px;
      @media screen and (min-width: 701px) {
        top: 0;
        right: 0;
        position: absolute;
        margin-right: 10px;
        margin-top: 15px;
      }
    }
  }
  .top_filters {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;
    @media screen and (max-width: 700px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  .filter-container {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
  }
  .filter-text {
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    color: #0f1734;
    margin-left: 16px;
    @media screen and (min-width: 701px) {
      display: none;
    }
  }
  .appliedFilter {
    font-weight: 700;
    font-size: 14px;
    color: #647490;
    line-height: 24px;
    @media screen and (max-width: 700px) {
      display: none;
    }
  }

  .filterTypeBox {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
    gap: 8px;
    background: #f1f5f9;
    border-radius: 6px;

    .filterTypeText {
      font-weight: 700;
      font-size: 14px;
      color: #0f1734;
    }
  }
  .clear-filter {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    cursor: pointer;
    white-space: nowrap;
    @media screen and (max-width: 700px) {
      margin-top: 16px;
      align-self: center;
    }
  }
}

.search-container {
  display: flex;

  .search-input {
    padding: 10px;
    border-radius: 8px 0 0 8px;
    // min-width: 350px;
    width: 50%;
    &:focus {
      outline: none;
    }
  }

  .search-input-state {
    border-left: 0;
    padding: 10px;
    // width: 350px;
    width: 50%;
    &:focus {
      outline: none;
    }
  }

  .search-button {
    max-width: 100px;
    border-radius: 0 8px 8px 0;

    @media screen and (max-width: 900px) {
      height: 42px;
    }

    &:focus {
      outline: none;
    }
  }
}

.input-placeholder {
  min-width: unset;
  padding: 7px 15px;

  &.male {
    border-radius: 8px 0px 0px 8px;
  }

  &.female {
    border-radius: 0px 0px 0px 0px;
    margin-left: -5px;
  }

  &.other {
    border-radius: 0 8px 8px 0px;
  }
}

.claim-card {
  border: 1px solid #ccc;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  .user-name {
    .bg-img {
      position: relative;
      border: 1px solid #ccc;
      min-width: 60px;
      max-width: 60px;
      min-height: 60px;
      max-height: 60px;
      border-radius: 50%;
      display: inline-block;

      .rating-badge {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 20%);
        font-size: 15px;
        border-radius: 20px;
        width: 55%;
      }
    }
  }

  .user-address {
    line-height: 15px;
  }

  .dovemed-card-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.125);

    span {
      font-size: 12px;
    }
  }
}

.claim-modal-header {
  border-radius: 5px 5px 0 0;
  min-height: 100px;
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;

  .profile-img {
    min-width: 150px;
    max-width: 150px;
    min-height: 150px;
    max-height: 150px;
    display: block;
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    box-shadow: 0px 5px 7px 0px rgba(0, 0, 0, 0.4);
  }
}

.profile-details {
  padding-top: 170px;
  max-width: 60%;
  margin: auto;
}

.terms-modal-container {
  padding: 30px;
  text-align: center;
}

.background-image {
  background-position: center !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
}

.filters-cont {
  transition: height 0.3s ease-in-out;
}

.transparent {
  opacity: 0;
  display: none;
}

.no-results-container {
  background: #f1f5f9;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding: 24px;
  margin-top: 48px;
  .no-results-icon {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background: #ffffff;
    margin-bottom: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .text1 {
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    color: #0f1734;
    margin-bottom: 8px;
  }
  .text2 {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #33415f;
    margin-bottom: 18px;
  }
  .text3 {
    font-weight: 700;
    font-size: 14px;
    line-height: 21px;
    color: #2a71d4;
    margin-bottom: 10px;
    cursor: pointer;
  }
}
.text-over {
  overflow: hidden;
  text-overflow: ellipsis;
}
.add-to-circle-btn {
  padding: 5px 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  font-size: 14px !important;
}

@media screen and (max-width: 581px) {
  .search-container {
    display: flex;
    flex-direction: column;

    .search-input {
      width: 100%;
      margin-bottom: 5px;
      border-radius: 8px;
      &-state {
        width: 100%;
        border-radius: 8px;
        margin-bottom: 5px;
      }
    }

    .search-button {
      border-radius: 8px;
      min-width: 100%;
    }
  }

  .filters-cont {
    .row {
      flex-direction: column;

      &-name {
        max-width: 100%;
      }

      &-city {
        max-width: 100%;
      }

      &-speciality {
        max-width: 100%;
      }
    }
  }

  .gender-section {
    display: flex;
  }
}
.page-info {
  margin-top: 48px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
}

.result-length {
  font-weight: 700;
  font-size: 20px;
  color: #0f1734;
  margin-bottom: 0px;
}

.sort-text {
  font-weight: 400;
  font-size: 14px;
  color: #0f1734;
  margin-bottom: 0px;
  cursor: pointer;
  white-space: nowrap;
  margin-left: 20px;
  display: flex;
  align-items: center;
  gap: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/ProviderDirectory.vue